// Mock data for Bricklane Restaurant

export const restaurantInfo = {
  name: "Bricklane",
  tagline: "Modern Indian Cuisine",
  location: "Arts District, Los Angeles",
  address: "1331 E 6th St, Los Angeles, CA 90021",
  phone: "(213) 395-0110",
  email: "hello@bricklane.la",
  hours: {
    weekdays: "5:00 PM - 10:00 PM",
    weekends: "12:00 PM - 11:00 PM"
  }
};

export const story = {
  title: "Our Story",
  subtitle: "A Vision Born from Passion and Innovation",
  content: [
    "Bricklane is the culmination of two visionary minds coming together: Executive Chef Sanjay Rawat and Co-Founder Rishma Shariff. Their shared passion for excellence and global culinary perspective creates an unprecedented dining experience in LA's Arts District.",
    "Chef Sanjay Rawat's journey began in his grandmother's kitchen in Uttarakhand, Northern India. After earning his culinary degree in Malaysia and mastering his craft at the 5-star Taj Hotel in New Delhi, he brought his expertise to America. Most recently, Chef Sanjay launched and led Kahani at The Ritz-Carlton, Laguna Niguel, where his innovative approach to Indian cuisine earned critical acclaim.",
    "Rishma Shariff brings a truly global sensibility to Bricklane. Born in Tanzania to an Indian family, she moved to Los Angeles at age 12, experiencing firsthand the beautiful collision of cultures that defines modern America. Her unique perspective - shaped by African roots, Indian heritage, and American dreams - infuses Bricklane with an authenticity that transcends borders.",
    "Together, they reimagine the vibrant spirit of London's iconic Brick Lane through a California lens. Each dish honors generations of family recipes while embracing contemporary techniques, local seasonal ingredients, and the creative energy of the Arts District."
  ],
  chef: {
    name: "Chef Sanjay Rawat",
    title: "Executive Chef & Co-Founder",
    background: "Former Executive Chef at Kahani, The Ritz-Carlton Laguna Niguel"
  },
  partner: {
    name: "Rishma Shariff",
    title: "Co-Founder",
    background: "Indian Tanzanian, Adventurer"
  }
};

export const menuHighlights = [
  // Chaat - 3 dishes
  {
    id: 1,
    name: "Curry Leaf & Garlic Focaccia",
    description: "Wood-fired sourdough infused with toasted curry leaves and roasted garlic. Served with whipped fresh herb and mustard butter.",
    category: "Chaat",
    image: "https://images.unsplash.com/photo-1763376385238-ba0211a17505"
  },
  {
    id: 2,
    name: "Darjeeling Tea Leaf Salad",
    description: "An aromatic, crunchy collision of fermented tea leaves, crispy garlic, Chana Dal, and toasted pumpkin seeds, finished with a ginger-cream silk.",
    category: "Chaat",
    image: "https://images.unsplash.com/photo-1672477179695-7276b0602fa9"
  },
  {
    id: 3,
    name: "Shakarkandi Chaat",
    description: "Japanese sweet potato charred in the tandoor until caramelized, served with yogurt ice cream, tamarind pearls, and the addictive snap of Chana Dal.",
    category: "Chaat",
    image: "https://images.unsplash.com/photo-1734330932655-e6f3e7aff297"
  },
  // Woodfire & Tandoor - 3 dishes
  {
    id: 4,
    name: "Lucknowi Lamb Galouti",
    description: "A melt-in-the-mouth heritage kebab. Velvety lamb paired with saffron-cashew gel and caramelized onion, served on a warm, sweet jaggery roti.",
    category: "Woodfire & Tandoor",
    image: "https://images.unsplash.com/photo-1734330931856-77cdf1b5bba9"
  },
  {
    id: 5,
    name: "Miso Masala Swordfish",
    description: "A coastal crossover. Firm swordfish marinated in miso and Indian spice, brightened with cucumber kimchi and a Yuzu-Dhaniya aioli.",
    category: "Woodfire & Tandoor",
    image: "https://images.unsplash.com/photo-1643757343278-5d50309dfa44"
  },
  {
    id: 6,
    name: "Lahori Boti Kebab",
    description: "Tender skirt steak charred in the tandoor, served over wood-fired pita with mint hummus, pickled onions, and a crisp micro-green salad.",
    category: "Woodfire & Tandoor",
    image: "https://images.unsplash.com/photo-1764435154725-9f966718d293"
  },
  // Reimagined Regions - 3 dishes
  {
    id: 7,
    name: "Applewood Smoked Butter Chicken",
    description: "A nostalgic classic reimagined. Locally grown tomatoes and cashew cream, finished with a theatrical applewood smoke, pomegranate seeds, and buttery lachha paratha.",
    category: "Reimagined Regions",
    image: "https://images.unsplash.com/photo-1603894584373-5ac82b2ae398"
  },
  {
    id: 8,
    name: "Slow-Cooked Laal Maas",
    description: "A fiery Rajasthani masterpiece. Tender lamb neck braised in a deep, burnt-chili purée and white onion.",
    category: "Reimagined Regions",
    image: "https://images.unsplash.com/photo-1545247181-516773cae754"
  },
  {
    id: 9,
    name: "Kasundi Macher Jhol",
    description: "Red Snapper poached in a pungent, soulful Bengali mustard sauce with crispy mustard leaves and a bright vinaigrette.",
    category: "Reimagined Regions",
    image: "https://images.unsplash.com/photo-1626777553635-be342a766ed0"
  },
  // Rustic Classics - 3 dishes
  {
    id: 10,
    name: "BrickLane 48-Hour Beef Nihari",
    description: "A labor of love. Silky, slow-cooked beef in a bone-marrow broth, served with traditional khamiri roti and dill raita.",
    category: "Rustic Classics",
    image: "https://images.unsplash.com/photo-1574653853027-5382a3d23a15"
  },
  {
    id: 11,
    name: "Champaran Lamb Handi",
    description: "Heritage lamb braised in clay pots with whole garlic bulbs and Kashmiri chili. Served with wood-fired butter naan.",
    category: "Rustic Classics",
    image: "https://images.unsplash.com/photo-1567188040759-fb8a883dc6d8"
  },
  {
    id: 12,
    name: "Mor Milagai Branzino",
    description: "Whole-fired branzino with a purple cabbage crunch and a decadent curry leaf butter sauce.",
    category: "Rustic Classics",
    image: "https://images.unsplash.com/photo-1519708227418-c8fd9a32b7a2"
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "/api/upload/images/b57dd0389093441f8ae04dcbc70eabef.jpg",
    alt: "Brera restaurant interior - open kitchen",
    caption: "Open kitchen experience"
  },
  {
    id: 2,
    url: "/api/upload/images/b57dd0389093441f8ae04dcbc70eabef.jpg",
    alt: "Chef's kitchen view",
    caption: "Chef's kitchen"
  },
  {
    id: 3,
    url: "/api/upload/images/b57dd0389093441f8ae04dcbc70eabef.jpg",
    alt: "Intimate dining setting",
    caption: "Intimate dining"
  },
  {
    id: 4,
    url: "/api/upload/images/b57dd0389093441f8ae04dcbc70eabef.jpg",
    alt: "Industrial warehouse space",
    caption: "Industrial elegance"
  },
  {
    id: 5,
    url: "/api/upload/images/b57dd0389093441f8ae04dcbc70eabef.jpg",
    alt: "Vibrant dinner service",
    caption: "Vibrant atmosphere"
  },
  {
    id: 6,
    url: "/api/upload/images/b57dd0389093441f8ae04dcbc70eabef.jpg",
    alt: "Full dining room view",
    caption: "Arts District dining"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Martinez",
    text: "An absolute revelation. Bricklane takes Indian cuisine to new heights while respecting its roots.",
    rating: 5
  },
  {
    id: 2,
    name: "James Chen",
    text: "The butter chicken is unlike anything I've had. The space is stunning. Can't wait to return.",
    rating: 5
  },
  {
    id: 3,
    name: "Priya Patel",
    text: "Finally, a modern Indian restaurant that gets it right. Authentic flavors, contemporary presentation.",
    rating: 5
  }
];

export const socialLinks = {
  instagram: "https://instagram.com/bricklane.la",
  facebook: "https://facebook.com/bricklane.la",
  tiktok: "https://tiktok.com/@bricklane.la"
};
